export const ACL = {
  OFFICER: 'Officer',
  MEMBER: 'Member',
  GUEST_MEMBER: 'Guest Member',
  GUEST: 'Guest',
  PUBLIC: 'Public',
}

export const normalizeAcl = (acl) => String(acl || '').trim()

export const isOfficer = (acl) => normalizeAcl(acl) === ACL.OFFICER

export const canManagePageBuilder = (authUser) => {
  const user = authUser?.user || authUser
  return Boolean(user?.isWebmaster) || isOfficer(user?.acl)
}

export const isMemberEquivalent = (acl) => {
  const normalized = normalizeAcl(acl)
  return normalized === ACL.OFFICER || normalized === ACL.MEMBER || normalized === ACL.GUEST_MEMBER
}

export const isGuestAudienceEquivalent = (acl) => {
  const normalized = normalizeAcl(acl)
  return isMemberEquivalent(normalized) || normalized === ACL.GUEST
}

export const hasMemberNumber = (acl) => {
  const normalized = normalizeAcl(acl)
  return normalized === ACL.OFFICER || normalized === ACL.MEMBER || normalized === ACL.GUEST_MEMBER
}

export const isPathwaysEligible = (acl) => {
  const normalized = normalizeAcl(acl)
  return normalized === ACL.OFFICER || normalized === ACL.MEMBER || normalized === ACL.GUEST_MEMBER
}

export const membershipBadgeClass = (acl) => {
  const normalized = normalizeAcl(acl)
  if (normalized === ACL.GUEST_MEMBER) {
    return 'guest-member'
  }
  return normalized.toLowerCase().replace(/\s+/g, '-')
}

export const canAccessAudience = (acl, audience) => {
  const normalizedAudience = normalizeAcl(audience)

  if (normalizedAudience === ACL.PUBLIC) return true
  if (normalizedAudience === ACL.OFFICER) return isOfficer(acl)
  if (normalizedAudience === ACL.MEMBER) return isMemberEquivalent(acl)
  if (normalizedAudience === ACL.GUEST) return isGuestAudienceEquivalent(acl)

  return false
}
